import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError, filter, map, take } from "rxjs/operators";
import { Endpoints } from "../../shared/config/endpoints";
import { GeneralService } from "../general.service";
import { Observable, of } from "rxjs";
import { customFormFieldPayload, customFormFieldPayloadResponse, SAMPLE_CUSTOM_FORM_FIELDS } from "src/app/data/clientService.data";


@Injectable({
  providedIn: "root",
})
export class ClientService {
  constructor(
    private http: HttpClient,
    private endpoints: Endpoints,
    private genServ: GeneralService
  ) { }

  // Handle Errors
  private handleError = (error: any): Observable<any> => {
    let message = "";
    if (error) {
      if (error.error) {
        message = error.error.message;
      } else {
        message = error.message;
      }
    }
    return of(null);
  };

  // Merge Endpoints
  private get getAllClientsUrl() {
    return (
      this.endpoints.leadsCompaniesContactClientsEndpoint +
      this.endpoints.clients.getOneGetAllClients
    );
  }
  private get getOneClientUrl() {
    return (
      this.endpoints.leadsCompaniesContactClientsEndpoint +
      this.endpoints.clients.getOneGetAllClients
    );
  }
  private get getClientsByFilterUrl() {
    return (
      this.endpoints.leadsCompaniesContactClientsEndpoint +
      this.endpoints.clients.getOneGetAllClients
    );
  }

  private get getClientsMergeUrl() {
    return (
      this.endpoints.leadsCompaniesContactClientsEndpoint +
      this.endpoints.clients.mergeCompanyContact
    );
  }

  // Clients Creation

  getAllClients() {
    return this.http.get(this.getAllClientsUrl);
  }

  getClientWildcard(value) {
    return this.http.get(
      this.endpoints.leadsCompaniesContactClientsEndpoint +
      `/clients/wildcard/${value}`
    );
  }

  //get array of

  getClientsByFilter(query) {
    try {
      return this.http
        .get(this.getClientsByFilterUrl + query)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getOneClient(id) {
    try {
      return this.http
        .get(`${this.getOneClientUrl}/${id}`)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getOneClientFullDetails(id) {
    try {
      return this.http
        .get(`${this.getOneClientUrl}/client/${id}`)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  mergerClients(fromClientId, toClientId) {
    try {
      return this.http
        .put(`${this.getClientsMergeUrl}/${fromClientId}/${toClientId}`, {})
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  importClients(payload) {
    const url = `${this.endpoints.fourFourSixEndpoint}/clients/imports`;
    return this.http.post(url, payload);
  }

  fetchCustomFormFields(companyID, moduleName) {
    const url = `${this.endpoints.customFormFieldsService}${companyID}/${moduleName}`;
    const headers = new HttpHeaders({
      Authorization: ''
    });
    return this.http.get<customFormFieldPayloadResponse>(url, {headers} ).pipe(
      filter((x) => !!x),
      take(1),
      map((response) => {
        return response.payload;
      })
    );
  }

  fetchCustomFormFieldsByDepartment(orgID, departmentID, moduleName) {
    const url = `${this.endpoints.customFormFieldsDepartmentService}${orgID}/${departmentID}/${moduleName}`;
    const headers = new HttpHeaders({
      Authorization: ''
    });
    return this.http.get<customFormFieldPayloadResponse>(url, {headers} ).pipe(
      filter((x) => !!x),
      take(1),
      map((response) => {
        return response.payload;
      })
    );
  }

  fetchSurveyTrigger(query: string) {
    const url = `${this.endpoints.fourFourSixEndpoint}/survey-trigger/${query}`;
    try {
      return this.http.get(url).pipe(
        catchError(this.handleError)
      );
    } catch (error) {
      alert(error);
    }
  }

  fetchSurveyTriggerForDepartment(query: string) {
    const url = `${this.endpoints.fourFourSixEndpoint}/survey-trigger/department${query}`;
    try {
      return this.http.get(url).pipe(
        catchError(this.handleError)
      );
    } catch (error) {
      alert(error);
    }
  }

  createSurveyTrigger(payload){
    const url = `${this.endpoints.fourFourSixEndpoint}/survey-trigger/update`;
    try {
      return this.http.post(url, payload).pipe(
        catchError(this.handleError)
      );
    } catch (error) {
      alert(error);
    }
  }

  fetchCustomerLocation(){
    try {
      return this.http.get(this.endpoints.geoLocation.uri).pipe(
        catchError(this.handleError)
      );
    } catch(error){
      alert(error);
    }
  }
  
  

  // const headers = new HttpHeaders();
  //   headers.set('Content-Type', undefined);
  //   return this.http.post(environment.baseURL+'api/v1/company/someFileUpload' , formData, {headers: headers})
  //     .pipe(
  //       catchError(this.formatErrors)
  //     );

  // addContactToCompany
  // :fromClientId/:toClientId
}
